import { winnercup } from "src/assets/images";
import cx from './imagecard.module.scss';
import { useEffect, useState } from "react";
import { Typography } from "src/components/common";
import Skeleton from "src/components/common/skeleton/Skeleton";

export default function ImageCard({ url, onRedirect, fallback, background, fallbackStyle, fallbackColor, height = '36px', width = '36px' }: { url: string | null, fallback: string | number, fallbackColor?: string; fallbackStyle?: any, onRedirect?: () => void; background?: string, height?: string, width?: string }) {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isImageValid, setIsImageValid] = useState<boolean>(true);

    useEffect(() => {
        if (!url) {
            setIsImageValid(false);
            setIsLoading(false);
            return;
        }

        // Prevent unnecessary reloading
        const img = new Image();
        img.src = url;

        if (img.complete) {
            setIsImageValid(true);
            setIsLoading(false);
            return;
        }

        setIsLoading(true);

        img.onload = () => {
            setIsImageValid(true);
            setIsLoading(false);
        };

        img.onerror = () => {
            setIsImageValid(false);
            setIsLoading(false);
        };

        return () => {
            img.onload = null;
            img.onerror = null;
        };
    }, [url]);
    return (
        <div className={cx.icon} style={isImageValid ? { border: '1px solid #fa461633', height, width, minHeight: height, minWidth: width } : background ? { background, height, width, minHeight: height, minWidth: width } : { background: 'linear-gradient(135deg, #FF6B35 0%, #FF8E53 100%)', height, width }} onClick={() => onRedirect && onRedirect()}>
            {isImageValid ? (
                <img key={url} src={url} style={isLoading ? { display: 'none', height, width } : { display: 'block', height, width }} />
            ) : (
                <Typography
                    as="h3"
                    variant="body-1"
                    fontWeight="semiBold"
                    className="profile-picture-component__error"
                    style={isLoading ? { display: 'none' } : { display: 'block', color: fallbackColor || '#fa4616', ...fallbackStyle }}
                >
                    {fallback}
                </Typography>
            )}
            {isLoading && <Skeleton style={{
                height,
                width,
                borderRadius: '8px'
            }} />}
        </div>
    )
}
